import React from "react";

export default ({ content, defaultValue, register }) => {
  return (
    <div className="select-input">
      <select {...register}>
        {content.map((option) => {
          return (
            <option
              key={option.value}
              label={option.label}
              value={option.value}
            />
          );
        })}
      </select>
    </div>
  );
};
